<h1>{{data.title1}}</h1>
<h2>{{data.title2}}</h2>
